import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, Observable, of, switchMap, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class ForwardGuard {
  constructor(
    private msalService: MsalService,
    private authService: AuthService,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.msalBroadcastService.inProgress$
      .pipe(
        tap((val)=>console.log(val)),
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        switchMap(() => {
          if (this.msalService.instance.getAllAccounts().length > 0) {
            //When logged in already, forward to app
            this.router.navigateByUrl(this.authService.redirectUrl || '/');
            console.log('User is already logged in. Will direct him to App!');
            return of(false);
          }

          //Otherwise Login Page is also allowed to be accessed
          console.log('User is not logged in. Will let him through to Login Page!');
          return of(true);
        })
      );
      
  }
}
